import { MaterialColors as Colors } from "@kaggle/core";
export var GREY_900 = Colors.GREY_900;
export var GREY_850 = Colors.GREY_850;
export var GREY_800 = Colors.GREY_800;
export var GREY_700 = Colors.GREY_700;
export var GREY_600 = Colors.GREY_600;
export var GREY_500 = Colors.GREY_500;
export var GREY_400 = Colors.GREY_400;
export var GREY_300 = Colors.GREY_300;
export var GREY_200 = Colors.GREY_200;
export var GREY_100 = Colors.GREY_100;
export var GREY_50 = Colors.GREY_50;
export var BLUE_600 = Colors.BLUE_600;
export var GREEN_600 = Colors.GREEN_600;
export var RED_600 = Colors.RED_600;
export var RED_50 = Colors.RED_50;
export var YELLOW_900 = Colors.YELLOW_900;
export var KAGGLE_BLUE = Colors.KAGGLE_BLUE;
export var KAGGLE_GREEN = Colors.KAGGLE_GREEN;
export var KAGGLE_PURPLE = Colors.KAGGLE_PURPLE;
export var KAGGLE_ORANGE = Colors.KAGGLE_ORANGE;
export var KAGGLE_YELLOW = Colors.KAGGLE_YELLOW;
export var KAGGLE_BLACK = Colors.KAGGLE_BLACK;
export var KAGGLE_WHITE = Colors.KAGGLE_WHITE;
export var KAGGLE_FOCUS = Colors.KAGGLE_FOCUS;
export var ILLUSTRATION_BLUE = Colors.ILLUSTRATION_BLUE;
export var ILLUSTRATION_GREEN = Colors.ILLUSTRATION_GREEN;
export var ILLUSTRATION_YELLOW = Colors.ILLUSTRATION_YELLOW;
export var ILLUSTRATION_BLACK = Colors.ILLUSTRATION_BLACK;
export var ELEVATION_1 = Colors.ELEVATION_1;
export var ELEVATION_2 = Colors.ELEVATION_2;
export var ELEVATION_3 = Colors.ELEVATION_3;
export var ELEVATION_4 = Colors.ELEVATION_4;
export var ELEVATION_5 = Colors.ELEVATION_5;
export var DARK_ELEVATION_1 = Colors.DARK_ELEVATION_1;
export var DARK_ELEVATION_2 = Colors.DARK_ELEVATION_2;
export var DARK_ELEVATION_3 = Colors.DARK_ELEVATION_3;
export var DARK_ELEVATION_4 = Colors.DARK_ELEVATION_4;
export var DARK_ELEVATION_5 = Colors.DARK_ELEVATION_5;
